/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { SimplicityComposerTipTap } from ".";
import { useEnsureTipTapContent } from "./use-ensure-tiptap-content";
import { defaultRichTextObjectPM } from "cms/components/components/defaults";
import { isObjectEmpty, exists } from "utils/empty-exists";

/**
 * @param {object} props
 * @param {any} props.richtext
 * @param {(content: import("@tiptap/react").JSONContent) => void} props.onChange
 */
const SimplicityComposerEnsureTipTap = (props) => {
    
    let richtext = props?.richtext;
    let enableQuoteDefault = props?.enableQuoteDefault;
    let className = props?.className;
    const onChange = props?.onChange;
    
    if (!exists(richtext)) {
        richtext = defaultRichTextObjectPM;
    }
    
    if (isObjectEmpty(richtext)) {
        richtext = defaultRichTextObjectPM;
    }
    
    const { tiptapContent } = useEnsureTipTapContent(richtext);
    
    return (
        <Fragment>
            <SimplicityComposerTipTap
                className={className}
                richtext={tiptapContent}
                enableQuoteDefault={enableQuoteDefault}
                onChange={onChange}
            />
        </Fragment>
    );
};
SimplicityComposerEnsureTipTap.displayName = "SimplicityComposerEnsureTipTap";
export { SimplicityComposerEnsureTipTap };
